import { takeEvery } from 'redux-saga/effects';
import getPeritajeSaga from "./getPeritaje/saga";
import searchPatentSaga from './searchPatent/saga'
import calculateRemainderSaga from './calculateRemainder/saga';
import clearBonificationTakingCar from './clearBonificationTakingCar/saga';
import showPresupuestoAlertsSaga from './showPresupuestoAlerts/saga';

import {
    PRESUPUESTADOR_GET_PERITAJE,
    PRESUPUESTADOR_SEARCH_PATENT,
    PRESUPUESTADOR_SET_BONIFICATION_TAKING_CAR_SUCCESS,
    PRESUPUESTADOR_CLEAR_VALIDATE_BONIFICATION_SALLER,
    PRESUPUESTADOR_GET_PERITAJE_SUCCESS,
    PRESUPUESTADOR_CLEAR_BON_USADO,
    PRESUPUESTADOR_REMOVE_ENTREGA_USADO,
    PRESUPUESTADOR_CLEAR_BONIFICATION_TAKING_CAR,
    PRESUPUESTADOR_SELECT_STOCK,
    PRESUPUESTADOR_UPDATE_TAKING_CAR,
    PRESUPUESTADOR_CLEAR_BONIFICATION_TAKING_CAR_SUCCESS,
    PRESUPUESTADOR_SEARCH_PATENT_SUCCESS,
    PRESUPUESTADOR_GET_COTIZACION_SUCCESS,
    PRESUPUESTADOR_DISABLE_BTN_SAVE,
    PRESUPUESTADOR_SOLICITAR_PERITAJE_BEGIN,
    PRESUPUESTADOR_SET_TEST_DRIVE,
    PRESUPUESTADOR_ADD_COMMENT,
    PRESUPUESTADOR_SPECIAL_BONIFICATION_SUCCESS,
    PRESUPUESTADOR_LOAD_ITEM_NUEVO_SUCCESS,
    PRESUPUESTADOR_SELECT_TIPO_VENTA,
    PRESUPUESTADOR_ON_CHANGE_SUMAR_CANTIDAD,
    PRESUPUESTADOR_CLEAR_ITEM_NUEVO,
    PRESUPUESTADOR_GET_ULTIMO_EDITADO_SUCCESS,
    PRESUPUESTADOR_SET_NEW_DELIVERY_COST
} from './constants';

import {
    CLIENTES_CLEAR_CLIENTE,
  } from '../../clientes/redux/constants';

import  disableBtnSaveSaga  from './setDisableBtnSave/saga';

// Watchers
export default function* presupuestador() {
    const disableBtnActions = [
        PRESUPUESTADOR_SEARCH_PATENT_SUCCESS,
        PRESUPUESTADOR_GET_COTIZACION_SUCCESS,
        PRESUPUESTADOR_REMOVE_ENTREGA_USADO,
        PRESUPUESTADOR_SET_BONIFICATION_TAKING_CAR_SUCCESS,
        PRESUPUESTADOR_CLEAR_BON_USADO,
        PRESUPUESTADOR_DISABLE_BTN_SAVE,
        PRESUPUESTADOR_SOLICITAR_PERITAJE_BEGIN,
        PRESUPUESTADOR_SET_TEST_DRIVE,
        CLIENTES_CLEAR_CLIENTE,
        PRESUPUESTADOR_ADD_COMMENT,
        PRESUPUESTADOR_UPDATE_TAKING_CAR,
        PRESUPUESTADOR_SET_NEW_DELIVERY_COST,
        PRESUPUESTADOR_ON_CHANGE_SUMAR_CANTIDAD
    ]

    const calculateRemainderActions = [
        PRESUPUESTADOR_SET_BONIFICATION_TAKING_CAR_SUCCESS,
        PRESUPUESTADOR_CLEAR_VALIDATE_BONIFICATION_SALLER,
        PRESUPUESTADOR_CLEAR_BON_USADO,
        PRESUPUESTADOR_GET_PERITAJE_SUCCESS,
        PRESUPUESTADOR_REMOVE_ENTREGA_USADO,
        PRESUPUESTADOR_SELECT_STOCK,
        PRESUPUESTADOR_UPDATE_TAKING_CAR,
        PRESUPUESTADOR_CLEAR_BONIFICATION_TAKING_CAR_SUCCESS,
        PRESUPUESTADOR_SPECIAL_BONIFICATION_SUCCESS,
        PRESUPUESTADOR_SELECT_TIPO_VENTA,
        PRESUPUESTADOR_LOAD_ITEM_NUEVO_SUCCESS,
        PRESUPUESTADOR_ON_CHANGE_SUMAR_CANTIDAD,
        PRESUPUESTADOR_CLEAR_ITEM_NUEVO
    ]

    const showAlerts = [
        PRESUPUESTADOR_LOAD_ITEM_NUEVO_SUCCESS,
        PRESUPUESTADOR_GET_ULTIMO_EDITADO_SUCCESS
    ]

    yield takeEvery(PRESUPUESTADOR_GET_PERITAJE, getPeritajeSaga);
    yield takeEvery(PRESUPUESTADOR_SEARCH_PATENT, searchPatentSaga);
    yield takeEvery(PRESUPUESTADOR_CLEAR_BONIFICATION_TAKING_CAR, clearBonificationTakingCar);
    yield takeEvery(showAlerts, showPresupuestoAlertsSaga);
    yield takeEvery(calculateRemainderActions, calculateRemainderSaga);
    yield takeEvery(disableBtnActions, disableBtnSaveSaga);

}